module.exports = __webpack_public_path__ + "static/media/3.b83122c8.png";